import { render, staticRenderFns } from "./InvitationProvider.vue?vue&type=template&id=91b39722&scoped=true&"
import script from "./InvitationProvider.vue?vue&type=script&lang=js&"
export * from "./InvitationProvider.vue?vue&type=script&lang=js&"
import style0 from "./InvitationProvider.vue?vue&type=style&index=0&id=91b39722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b39722",
  null
  
)

export default component.exports